import { useState } from 'react'

import { useEffect } from 'modules/core/hooks/useEffect'

import { useHapiElementsContext } from 'modules/ats/components/HapiElementsLoader'
import type { Campaign } from 'modules/ats/lib/vonq'

export const useGetJobCampaigns = (jobId: number) => {
  const { elementsLoaded } = useHapiElementsContext()
  const [loading, setLoading] = useState(false)
  const [campaigns, setCampaigns] = useState<Campaign[]>([])

  useEffect(() => {
    if (!elementsLoaded) {
      return
    }

    async function fetchData() {
      const response = await window.hapi.campaign.service?.getCampaigns.run(0, 100, {
        factorialJobId: jobId.toString(),
      })

      if (!response) {
        return
      }

      setCampaigns(response.data)
    }

    fetchData()

    window.hapi.campaign.state.campaignsAreLoading.onChange((newValue: boolean) => {
      setLoading(newValue)
    })

    window.hapi.campaign.state?.campaigns.onChange((newValue: Campaign[]) => {
      setCampaigns(newValue)
    })
  }, [elementsLoaded, jobId])

  return { loading, campaigns }
}
